import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/variables.scss'
import '@/assets/styles/global.scss'
import request from './utils/request'
import i18n, { applyElementLocale } from './i18n'

// Configure Element UI
Vue.use(ElementUI)

// Apply Element UI locale based on saved language
applyElementLocale(i18n.locale)

// Mount axios instance to Vue prototype
Vue.prototype.$axios = request

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err, info)
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
